<template>
  <div class="subtitle-music">
    <!-- 字幕音乐 -->
    <div class="subtitle-music-top">
      <span>
        <img src="../../assets/img/home-icon.png" alt="" class="home-icon-img">
        <router-link :to="{ name: 'home' }">首页</router-link>
      </span>&nbsp;/&nbsp;
      <span>
        素材管理
      </span>&nbsp;/&nbsp;
      <span>
        字幕配音
      </span>
      <el-button icon="el-icon-back" class="retrunbtn" type="text" @click="urlback" v-if="referer">返回</el-button>
    </div>
    <div class="subtitle-music-content material-list">
      <audio ref="audio" controls id="audio" style="position: fixed;bottom: 10px;left :10px;" hidden></audio>
      <!--  -->
      <el-table :data="subtitleMusicData" style="width: 100%"
        :header-cell-style="{ backgroundColor: '#f1f1f1', color: '#000', fontSize: '14px', fontWeight: '400' }" stripe
        v-loading="loading">
        <el-table-column prop="name" label="名称" width="200px">
        </el-table-column>
        <el-table-column prop="language" label="语种" align="center">
        </el-table-column>
        <el-table-column prop="operation" label="操作" align="center" width="60px">
          <template slot-scope="scope">
            <el-button @click="operationHandle(scope.row)" type="text" size="small">
              <img src="../../assets/img/play-icon.png" alt="">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--  -->
      <div class="subtitle-music-page">

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'subtitleMusicPage',
  data() {
    return {
      // 表格数据
      subtitleMusicData: [],
      // 分页
      currentPage: 1,
      tag: true,
      audioUrl: '',
      loading: false,
      language: 'cn'
    }
  },
  created() {
    var query = this.$route.query;
    this.referer = query.referer;
    this.query();
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.audio.pause();
    next();
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    // 播放
    operationHandle(row) {
      this.$refs.audio.src = row.url;
      this.$refs.audio.play();
    },
    query() {
      this.loading = true;
      this.$get('/audio/list').then(res => {
        this.subtitleMusicData = res.data;
        this.loading = false;
      })
    },
    urlback() {
      this.$router.go(-1);
    },
  },
}

</script>
<style scoped>
.subtitle-music-top {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 3px;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 16px 20px;
}

.subtitle-music-top {
  color: #606266;
  font-size: 14px;
}

.subtitle-music-top .home-icon-img {
  margin-right: 4px;
}

.subtitle-music-top a {
  color: #606266;
}

.subtitle-music-top a:hover {
  color: #006cff;
}

.subtitle-music-content {
  background-color: #fff;
  box-sizing: border-box;
  padding: 20px 30px 20px 20px;
  position: relative;
  height: calc(100vh - 150px);
}

.subtitle-music-page {
  display: flex;
  align-content: center;
  justify-content: right;
  margin-top: 20px;
  /* position: absolute; */
  bottom: 30px;
  left: 16%;
}

.subtitle-music-page .el-pagination {
  color: #606266;
  font-weight: 400;
}

.subtitle-music-page .el-pagination>>>button {
  border: 1px solid #d9d9d9 !important;
  border-radius: 3px;
  padding: 0;
  min-width: 28px !important;
}

.subtitle-music-page .el-pagination .btn-next,
.el-pagination .btn-prev {
  background: center center no-repeat #FFF;
  background-size: 16px;
  cursor: pointer;
  margin: 0;
  color: #606266;
}

.subtitle-music-page .el-pagination .el-select .el-input {
  width: 90px;
  margin: 0 5px;
}

.subtitle-music-page .el-pagination>>>.el-pagination__jump {
  margin-left: 10px;
  font-weight: 400;
  color: #606266;
}

.subtitle-music-content>>>.el-table .el-table__body tr:hover>td {
  background-color: #e3eefd !important;
}

.subtitle-music-content>>>.el-table .el-table__body tr.current-row>td {
  background-color: #e3eefd !important;
}

.subtitle-music-content>>>.el-table__row--striped {
  background-color: #f7f8f8;
}

.subtitle-music-content>>>.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background-color: #f7f8f8;
}
</style>